export const DOCUMENTS = "DOCUMENTS";
export const DOCUMENTS_LOADING = "DOCUMENTS_LOADING";
